import { patchUrlMappings } from '@discord/embedded-app-sdk'
import { getAudioAssets, getHealth } from './api/gameApiClient'
import { ColyseusClient } from './colyseus/colyseus'
import { setupDiscordSdk } from './discord/authApiClient'
import './font.css'
import { MyGame } from './game/game'
import { phaserRuntimeConfig } from './game/phaser.config'

import './style.css'

const isProd = process.env.NODE_ENV === 'production'
if (isProd) {
	patchUrlMappings([{ prefix: '/', target: 'wejam.hammertime.studio' }])
}

getHealth()
getAudioAssets().then(async (gameConfig) => {
	const discordSdk = await setupDiscordSdk()
	const colyseusClient = new ColyseusClient()
	const room = await colyseusClient.init(discordSdk)
	const game = new MyGame(phaserRuntimeConfig)
	game.scene.start('main', { ...gameConfig, room, discordSdk })
})
